export const CRM_CUSTOMER_BASE_PATH =
    "ux-consulta-contactos-Hogar-gen/ecommerce-hogar/soporte-ti/v1";
export const CRM_CREATE_CUSTOMER_BASE_PATH =
    "ux-registra-contactos-hogar-gen/ecommerce-hogar/soporte-ti/v1";
export const CRM_OPPORTUNITY_BASE_PATH =
    "ux-crea-leads-hogar-gen/ecommerce-hogar/soporte-ti/v1";
export const CRM_PHASE_BASE_PATH =
    "ux-actualiza-leads-hogar-gen/ecommerce-hogar/soporte-ti/v1";

export const OCP_APIM_TRACE = "true";
export const IDTRX = "1";
export const CLTID = "1";
export const NAME_APLICATION = "crm";
export const USER_APLICATION = "crm";
export const PROCESS_BUSSINES = "crm";
